export const SET_SCROLL_POS = 'SET_SCROLL_POS'

// dashboard
export const SET_WIDGETS = 'SET_WIDGETS'
export const SET_SHOW_TIME_TRACKER_WIDGET = 'SET_SHOW_TIME_TRACKER_WIDGET'
